/* holy-collection — client-side facet filter + progressive dock + chips + quick add +
   Provision continuation. Products are server-rendered; this attaches behavior to the
   existing DOM. Scoped per .hc instance so it's reusable on any page. */
(function(){
  /* ── Quick add plumbing (shared) — mirrors the PDP add path: POST /cart/add.js with a
     sections payload, refresh the house <cart-drawer> (#CartDrawer) from it and open it,
     then re-render the S3 header nav so account→bag + count reflect server truth. ── */
  function refreshHeaderNav(){
    var bar=document.querySelector('.s3-bar'); if(!bar)return;
    var wrap=bar.closest('[id^="shopify-section-"]'); if(!wrap)return;
    fetch(window.location.pathname+'?section_id='+wrap.id.replace('shopify-section-',''),{headers:{'Accept':'text/html'}})
      .then(function(r){return r.text();})
      .then(function(html){
        var doc=new DOMParser().parseFromString(html,'text/html');
        var freshNav=doc.querySelector('.s3-nav'),nav=bar.querySelector('.s3-nav');
        if(freshNav&&nav)nav.innerHTML=freshNav.innerHTML;
      }).catch(function(){});
  }
  function drawerSectionId(){
    var cd=document.querySelector('cart-drawer'); if(!cd)return '';
    var wrap=cd.closest('[id^="shopify-section-"]');
    return wrap?wrap.id.replace('shopify-section-',''):'';
  }
  function syncCart(res){
    try{
      var cd=document.querySelector('cart-drawer');
      var sid=drawerSectionId();
      if(cd&&res&&res.sections&&sid&&res.sections[sid]){
        var el=document.getElementById('CartDrawer');
        if(el){
          var fresh=new DOMParser().parseFromString(res.sections[sid],'text/html').querySelector('#CartDrawer');
          if(fresh)el.innerHTML=fresh.innerHTML;
        }
        cd.classList.remove('wt-cart--empty','holy-cart-drawer--empty','is-empty');
      }
      if(cd&&cd.dataset.cartType!=='page'&&!cd.isOpen&&typeof cd.toggleDrawerClasses==='function')cd.toggleDrawerClasses();
    }catch(e){}
    refreshHeaderNav();
  }
  function quickAdd(btn,busy,done){
    if(btn.classList.contains('is-adding')||btn.classList.contains('is-added'))return;
    var id=btn.getAttribute('data-quick-add'); if(!id)return;
    var orig=btn.textContent;
    btn.classList.add('is-adding'); btn.textContent=busy;
    var fd=new FormData();
    fd.append('id',id); fd.append('quantity','1');
    var sid=drawerSectionId();
    if(sid){ fd.append('sections',sid); fd.append('sections_url',window.location.pathname); }
    fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},body:fd})
      .then(function(r){return r.json();})
      .then(function(res){
        if(res&&res.status&&res.status>=400)throw res;
        btn.classList.remove('is-adding'); btn.classList.add('is-added'); btn.textContent=done;
        syncCart(res);
        setTimeout(function(){btn.classList.remove('is-added'); btn.textContent=orig;},1800);
      })
      .catch(function(){btn.classList.remove('is-adding'); btn.textContent=orig;});
  }

  function init(root){
    var grid=root.querySelector('.cat-grid--main')||root.querySelector('.cat-grid');
    var grids=[].slice.call(root.querySelectorAll('.cat-grid'));
    var facetsEl=root.querySelector('.facets');
    if(!grid||!facetsEl)return;
    var countEl=root.querySelector('.hc-count'),
        emptyEl=root.querySelector('.empty'),
        seg=root.querySelector('.facets__seg'),
        clearBtn=root.querySelector('.facets__clear'),
        colToggle=root.querySelector('.col-toggle'),
        subnav=root.querySelector('.subnav'),
        provPool=root.querySelector('[data-prov-pool]'),
        moreWrap=root.querySelector('[data-prov-more]'),
        moreBtn=root.querySelector('[data-prov-more-btn]'),
        provAll=root.querySelector('[data-prov-all]'),
        addBusy=root.getAttribute('data-add-busy')||'…',
        addDone=root.getAttribute('data-add-done')||'✓',
        provOn=false;
    var sel={};  // {category:[values]} — AND across categories, OR within

    /* ── Quick add — capture pre-empts tile navigation + tap-to-flip ── */
    root.addEventListener('click',function(e){
      var b=e.target.closest('[data-quick-add]');
      if(!b||!root.contains(b))return;
      e.preventDefault(); e.stopImmediatePropagation();
      quickAdd(b,addBusy,addDone);
    },true);
    root.addEventListener('keydown',function(e){
      if(e.key!=='Enter'&&e.key!==' ')return;
      var b=e.target.closest('[data-quick-add]'); if(b!==e.target)return;
      e.preventDefault(); e.stopImmediatePropagation();
      quickAdd(b,addBusy,addDone);
    },true);

    /* ── Provision continuation — same grid, no break. The section renders Provision tiles
       into a hidden pool; on the LAST page of the main collection we fill the page's
       remaining slots, then [data-prov-more] reveals the rest a page-size at a time.
       Earlier pages show no Provision (the main collection continues there). ── */
    function provTiles(){return provPool?[].slice.call(provPool.querySelectorAll('.prod')):[];}
    function appendProv(n){
      var pool=provTiles(),i;
      for(i=0;i<n&&i<pool.length;i++)grid.appendChild(pool[i]);
      var left=provTiles().length;
      if(moreWrap)moreWrap.hidden=!left;
      if(provAll)provAll.hidden=!!left;
    }
    if(provPool&&grid.getAttribute('data-has-next')!=='1'&&provTiles().length){
      provOn=true;
      var pageSize=parseInt(grid.getAttribute('data-page-size'),10)||24;
      if(moreWrap)grid.parentNode.insertBefore(moreWrap,grid.nextSibling); /* show-more sits right under the grid */
      var fill=pageSize-grid.querySelectorAll('.prod:not([data-prov])').length;
      appendProv(fill>0?fill:0);
      if(moreBtn)moreBtn.addEventListener('click',function(){appendProv(pageSize);});
    }

    function applyFilter(){
      /* main tiles only — Provision continuation tiles (data-prov) are excluded from
         filters + counts by design and ride only the unfiltered view */
      var cards=grid.querySelectorAll('.prod:not([data-prov])'),shown=0;
      cards.forEach(function(c){var ok=true;
        for(var k in sel){ if(sel[k].length && sel[k].indexOf(c.getAttribute('data-'+k))<0){ok=false;break;} }
        c.hidden=!ok; if(ok)shown++; });
      var any=Object.keys(sel).some(function(k){return sel[k].length;});
      grid.querySelectorAll('.prod[data-prov]').forEach(function(c){c.hidden=any;});
      if(provOn&&moreWrap)moreWrap.hidden=any||!provTiles().length;
      if(provOn&&provAll)provAll.hidden=any||!!provTiles().length;
      if(countEl)countEl.textContent=shown+(shown===1?' product':' products');
      if(emptyEl)emptyEl.classList.toggle('show',shown===0);
      if(clearBtn)clearBtn.classList.toggle('show',any);
    }

    /* segment: category locks dark + nests its row (toggle) */
    if(seg)seg.querySelectorAll('button').forEach(function(b){b.addEventListener('click',function(){
      var f=b.dataset.facet,was=b.classList.contains('is-active');
      seg.querySelectorAll('button').forEach(function(x){x.classList.remove('is-active');});
      root.querySelectorAll('.facets__row').forEach(function(r){r.classList.remove('is-active');});
      if(!was){b.classList.add('is-active');var row=root.querySelector('.facets__row[data-facet="'+f+'"]');if(row)row.classList.add('is-active');}
    });});

    /* pill select (dark) + filter — delegated */
    facetsEl.addEventListener('click',function(e){
      var p=e.target.closest('.facet-pill'); if(!p||!facetsEl.contains(p))return;
      var row=p.closest('.facets__row'); if(!row)return;
      var cat=row.dataset.facet,val=p.dataset.val;
      p.classList.toggle('is-selected');
      sel[cat]=sel[cat]||[];
      var i=sel[cat].indexOf(val); if(i<0)sel[cat].push(val); else sel[cat].splice(i,1);
      applyFilter();
    });

    /* clear all */
    if(clearBtn)clearBtn.addEventListener('click',function(){
      sel={}; root.querySelectorAll('.facet-pill.is-selected').forEach(function(p){p.classList.remove('is-selected');}); applyFilter();
    });

    /* column toggle — swap only the grid-cols-* class so modifiers survive; applies to every grid */
    if(colToggle)colToggle.querySelectorAll('button').forEach(function(btn){btn.addEventListener('click',function(){
      grids.forEach(function(g){
        g.className=g.className.replace(/\bgrid-cols-\d+\b/g,'').trim()+' grid-cols-'+btn.dataset.cols;
      });
      colToggle.querySelectorAll('button').forEach(function(b){b.classList.toggle('is-active',b===btn);});
    });});

    /* DOCK is pure CSS sticky (header → subnav → facets stack). JS only measures the subnav height
       so the facet bar pins flush beneath the docked subnav. */
    function setSubnavH(){ root.style.setProperty('--hc-subnav-h',(subnav?subnav.offsetHeight:0)+'px'); }
    setSubnavH();
    window.addEventListener('resize',setSubnavH,{passive:true});
    if(window.ResizeObserver && subnav){ new ResizeObserver(setSubnavH).observe(subnav); }

    /* CSM dots + tap-to-flip apply to EVERY grid (Provision tiles live in the main grid too) */
    grids.forEach(function(g){
      /* CSM dots — click/tap toggles the tooltip; never navigates the card (capture pre-empts the card tap) */
      g.addEventListener('click',function(e){
        var dot=e.target.closest('.csm-dot'); if(!dot)return;
        e.preventDefault(); e.stopImmediatePropagation();
        var was=dot.classList.contains('is-open');
        g.querySelectorAll('.csm-dot.is-open').forEach(function(d){d.classList.remove('is-open');});
        if(!was)dot.classList.add('is-open');
      },true);

      /* tap-to-reveal the flip face on touch (first tap flips; second tap follows the link) */
      if(window.matchMedia('(pointer:coarse)').matches){
        g.addEventListener('click',function(e){
          if(e.target.closest('[data-quick-add]'))return; /* Add taps never flip */
          var c=e.target.closest('.prod'); if(!c)return;
          if(!c.querySelector('.hover-layer') && !c.querySelector('.studio-default__hover'))return;
          if(!c.classList.contains('is-tapped')){ e.preventDefault();
            g.querySelectorAll('.prod.is-tapped').forEach(function(x){if(x!==c)x.classList.remove('is-tapped');});
            c.classList.add('is-tapped');
          }
        });
      }
    });
  }
  if(document.readyState!=='loading')document.querySelectorAll('.hc').forEach(init);
  else document.addEventListener('DOMContentLoaded',function(){document.querySelectorAll('.hc').forEach(init);});
})();
